import { Helmet, PageTitle } from "@app/components/atoms";
import { DescriptionOutlined } from "@mui/icons-material";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { clearMachineReportsPreferences } from "@app/helpers";
import { getTradeMarkData } from "@app/api";
import React from "react";

type TrademarkItem = {
  name: string;
};

export function Trademark() {
  const { t } = useTranslation();
  const [items, setItems] = useState<TrademarkItem[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    clearMachineReportsPreferences();

    const fetchData = async () => {
      try {
        const response = await getTradeMarkData();
        setItems(response.data.data || []);
      } catch (error) {
        console.error("Failed to fetch trademark data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="group-list-page trademark">
      <Helmet title={t("metaInfo.tradeMark")} />
      <div className="container">
        <div className="row">
          <div className="sp-p24">
            {/* <NavigationItem title={t("license.backToHome")} /> */}
            <PageTitle title="tradeMark.title" className="mt-24 mb-25">
              <DescriptionOutlined />
            </PageTitle>
          </div>

          <Box className="sp-p24" sx={{ width: "100%" }}>
            <Stack spacing={2}>
              {loading ? (
                <Typography variant="body2" color="text.secondary">
                  {t("")}
                </Typography>
              ) : items.length === 0 ? (
                <Typography variant="body2" color="text.secondary">
                  {t("")}
                </Typography>
              ) : (
                items.map((item, idx) => (
                  <Paper
                    key={idx}
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: "#fff",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        lineHeight: 1.6,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "anywhere",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1,
                      }}
                    >
                      <Box
                        component="span"
                        aria-hidden="true"
                        sx={{
                          lineHeight: 1.6,
                          mt: "2px",
                        }}
                      >
                        •
                      </Box>
                      <span>
                        {item.name?.split("®").map((part, index) => (
                          <React.Fragment key={index}>
                            {part}
                            {index < item.name.split("®").length - 1 && (
                              <span
                                style={{
                                  fontSize: "0.65em",
                                  position: "relative",
                                  top: "-0.45em",
                                  marginLeft: "1px",
                                }}
                              >
                                ®
                              </span>
                            )}
                          </React.Fragment>
                        ))}
                      </span>
                    </Typography>
                  </Paper>
                ))
              )}
            </Stack>
          </Box>
        </div>
      </div>
    </div>
  );
}
